import { lazy } from 'react';

export const CatalogMatchJobDetailsPageAsync = lazy(
  () => import('./CatalogMatchJobDetails'),
);
